import React from 'react';

import StoreInfoModalContainer from 'components/store-info-modal';
import { Route, Routes } from 'state/location';
import { relativeRoutes } from 'utils/routing';

export const StoreInfoRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Store info requests data by id and/or storeNumber supplied depending on route. */}
      <Route path={`${relativeRoutes.store}/:id`} element={<StoreInfoModalContainer />} />
      <Route
        path={`${relativeRoutes.store}/:storeNumber/*`}
        element={<StoreInfoModalContainer />}
      />
    </Routes>
  );
};
